export default __webpack_public_path__ + "static/media/head01_vi_sp.f110fdc1.png";